import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class PurposeOfDeposits extends KYCQuestion
{
	state = {
		fields: {
			checkbox_customer_kyc_purpose: {
				options: [
					{
						label: "Ekonomisk trygghet",
						value: "yes",
						name: "checkbox_aml_purpose_econ_sec",
						checked: false
					},
					{
						label: "Gåva till närstående",
						value: "yes",
						name: "checkbox_aml_purpose_gift",
						checked: false
					},
					{
						label: "Pension",
						value: "yes",
						name: "checkbox_aml_purpose_pension",
						checked: false
					},
					{
						label: "Privat konsumtion",
						value: "yes",
						name: "checkbox_aml_purpose_consump",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "checkbox_customer_kyc_purpose";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="checkbox"
					name="checkbox_customer_kyc_purpose"
					description="Vad är syftet med ditt sparande och/eller dina placeringar?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.checkbox_customer_kyc_purpose.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/PurposeOfDeposits.js